// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MimaFilter_filter__gv8jg {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 3rem;
  background-color: var(--color-white);
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
  height: -moz-fit-content;
  height: fit-content;
}
.MimaFilter_filter_button__JCcXo {
  display: flex;
  align-items: center;
  color: var(--color-dark);
  padding: 0 1rem;
  cursor: pointer;
  font-size: var(--default-font-small);
}
.MimaFilter_filter_button__JCcXo:hover {
  color: var(--color-dark);
}
.MimaFilter_filter_button_icon__kkU8o {
  font-size: 3rem;
  margin-right: 1rem;
}
.MimaFilter_filter_line__Z7nig {
  margin-top: 1rem;
  border-top: 1px solid var(--color-fash-primary);
}
.MimaFilter_filter_content__tbKEd {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 2rem;
  gap: 1rem;
}
.MimaFilter_filter_content__tbKEd > :not(last-child) {
  margin-right: 1rem;
}
@media only screen and (max-width: 43.75em) {
  .MimaFilter_filter_content__tbKEd > :not(last-child) {
    margin-bottom: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MimaFilter/MimaFilter.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,4CAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;AADJ;AAGI;EACE,wBAAA;AADN;AAII;EACE,eAAA;EACA,kBAAA;AAFN;AAME;EACE,gBAAA;EACA,+CAAA;AAJJ;AAOE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AALJ;AAOI;EACE,kBAAA;AALN;AAOM;EAHF;IAII,mBAAA;EAJN;AACF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.filter {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 1rem 3rem;\n  background-color: var(--color-white);\n  border-radius: 1rem;\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  margin-bottom: 2rem;\n  height: fit-content;\n\n  &_button {\n    display: flex;\n    align-items: center;\n    color: var(--color-dark);\n    padding: 0 1rem;\n    cursor: pointer;\n    font-size: var(--default-font-small);\n\n    &:hover {\n      color: var(--color-dark);\n    }\n\n    &_icon {\n      font-size: 3rem;\n      margin-right: 1rem;\n    }\n  }\n\n  &_line {\n    margin-top: 1rem;\n    border-top: 1px solid var(--color-fash-primary);\n  }\n\n  &_content {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    margin-bottom: 2rem;\n    gap: 1rem;\n\n    & > :not(last-child) {\n      margin-right: 1rem;\n\n      @media only screen and (max-width: $bp-700) {\n        margin-bottom: 2rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter": `MimaFilter_filter__gv8jg`,
	"filter_button": `MimaFilter_filter_button__JCcXo`,
	"filter_button_icon": `MimaFilter_filter_button_icon__kkU8o`,
	"filter_line": `MimaFilter_filter_line__Z7nig`,
	"filter_content": `MimaFilter_filter_content__tbKEd`
};
export default ___CSS_LOADER_EXPORT___;
